import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
import { AlertService } from "../../alerts/alert.service";
import { AlignResponsesService } from "../../services/align-responses.service";

@Component({
  selector: "app-confirm-delete-align-response-modal",
  templateUrl: "./confirm-delete-align-response-modal.component.html",
})
export class ConfirmDeleteAlignResponseModalComponent implements OnInit {
  title: string;
  closeBtnName: string;
  submitBtnName = "Delete";
  data: any = {};
  formModel: any = {};
  public confirmModalName = "confirm-delete-align-response-modal";
  public shouldRefresh = false;
  selectedNames = "";
  constructor(
    public bsModalRef: BsModalRef,
    private alertService: AlertService,
    private alignResponsesService: AlignResponsesService
  ) {}

  ngOnInit() {
    this.selectedNames = this.data.selectedSubmissionInfo.join(", ");
  }

  delete() {
    this.shouldRefresh = true;
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    const questBlockKey = this.data.questBlockKey;
    (this.data.isDeleteAll && this.data.selectedSubmissionIDs.length > 1
      ? this.alignResponsesService.deleteAllUnaligned(questBlockKey)
      : this.alignResponsesService.deleteMultipleUnaligned(
          questBlockKey,
          this.data.selectedSubmissionIDs
        )
    )
      .then((message) => {
        this.alertService.show(message.message, "success");
        this.bsModalRef.hide();
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        console.log(message);
      })
      .catch((msg) => {
        const alertService = this.alertService;

        if (!Array.isArray(msg.error.errors)) {
          msg.error.errors = Object.values(msg.error.errors);
        }

        msg.error.errors.forEach(function (val: any) {
          console.log(val);
          if (!Array.isArray(msg.error.errors)) {
            alertService.show(msg.error.message, "danger");
          } else {
            val.forEach(function (innerVal: any) {
              alertService.show(innerVal, "danger");
            });
          }
        });

        this.bsModalRef.hide();
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      });
  }
}
